import React, { Component } from 'react'
import { extendObservable } from 'mobx'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import omit from 'lodash/omit'

import { expertApi } from '@atheneum/api'

import Button from '@components/Button'
import { showDialog } from '@components/Dialog'
import Spinner from '@components/spinner'
import OptionGroup from '@components/OptionGroup'
import CheckboxOption from '@components/OptionGroup/CheckboxOption'

import GetContactInfo from '../GetContactInfo'

class GetContactInfoModal extends Component {
  static propTypes = {
    expertStore: PropTypes.object,
    modalStore: PropTypes.object,
    growlStore: PropTypes.object,
    staticData: PropTypes.object
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      selectedPhones: [],
      selectedEmails: []
    })
  }

  save = async () => {
    const { expertStore, growlStore, modalStore } = this.props
    const { expert } = expertStore

    const data = {
      phones: this.selectedPhones.map(phone => omit(phone, 'company')),
      emails: this.selectedEmails.map(email => omit(email, 'company'))
    }

    this.isSubmitting = true

    try {
      await expertApi.updateContactInfo(expertStore.expert.id, data)
      expertStore.get(expert.id)
      modalStore.close()
      growlStore.showSuccess('Contact information saved')
    } catch (err) {
      growlStore.showError(err)
    }
  }

  handleEmailsChange = emails => {
    this.selectedEmails.replace(emails)
  }

  handlePhonesChange = phones => {
    this.selectedPhones.replace(phones)
  }

  handleError = error => {
    this.props.growlStore.showError(error)
    this.props.modalStore.close()
  }

  handleContactInfoNotFound = ({ fullName }) => {
    this.props.modalStore.close()

    return showDialog({
      type: 'info',
      title: 'Not Found',
      text: `No contact info found for ${fullName}`
    })
  }

  renderPhoneNumberPicker = (phoneNumbers, phoneToString) => {
    const { handlePhonesChange, selectedPhones } = this

    if (phoneNumbers.length) {
      return (
        <OptionGroup
          noStyle
          className='contact-info-picker__options-wrapper'
          items={phoneNumbers}
          itemToString={phoneToString}
          selectedItems={selectedPhones}
          renderItem={CheckboxOption}
          onChange={handlePhonesChange}
        />
      )
    }

    return <span className='text-gray'>No phone numbers available</span>
  }

  renderEmailAddressPicker = (emailAddresses, emailToString) => {
    const { selectedEmails, handleEmailsChange } = this

    if (emailAddresses.length) {
      return (
        <OptionGroup
          noStyle
          className='contact-info-picker__options-wrapper'
          items={emailAddresses}
          itemToString={emailToString}
          selectedItems={selectedEmails}
          renderItem={CheckboxOption}
          onChange={handleEmailsChange}
        />
      )
    }

    return <span className='text-gray'>No email addresses available</span>
  }

  render () {
    const { selectedEmails, selectedPhones } = this
    const { expertStore } = this.props

    const nothingSelected = !selectedEmails.length && !selectedPhones.length

    return (
      <GetContactInfo
        expert={expertStore.expert}
        staticData={this.props.staticData}
        onContactInfoNotFound={this.handleContactInfoNotFound}
        onError={this.handleError}
      >
        {({
          phoneNumbers,
          emailAddresses,
          phoneToString,
          emailToString,
          loading
        }) => {
          if (loading) return <Spinner />
          return (
            <div className='expert-form contact-info-form'>
              <h1 className='expert-form__title'>Get contact information</h1>
              <div>
                <div className='expert-form__section'>
                  <h2 className='expert-form__subtitle'>Phone numbers</h2>
                  {this.renderPhoneNumberPicker(phoneNumbers, phoneToString)}
                </div>
                <div className='expert-form__section'>
                  <h2 className='expert-form__subtitle'>Email addresses</h2>
                  {this.renderEmailAddressPicker(emailAddresses, emailToString)}
                </div>
              </div>
              <div className='expert-form__section expert-form__section--buttons'>
                <Button
                  primary
                  submit
                  onClick={this.save}
                  disabled={this.isSubmitting || nothingSelected}
                >
                  Save
                </Button>
                <Button onClick={this.props.modalStore.close}>Cancel</Button>
              </div>
            </div>
          )
        }}
      </GetContactInfo>
    )
  }

  static defaultProps = {
    hideButtons: true,
    showCloseIcon: true,
    shouldCloseOnOverlayClick: true
  }
}

export default inject(
  'modalStore',
  'growlStore',
  'staticData'
)(observer(GetContactInfoModal))
